export const products = [
  {
    id: 1,
    name: 'Nightmare Signature Dri-Fit Hoodie',
    price: 34.99,
    category: 'HOODIES',
    image: 'https://public.readdy.ai/ai/img_res/edited_33777cc3fc55ef6594947cc28442666e_bd52eba8.jpg',
    badge: 'NEW',
  },
  {
    id: 2,
    name: 'Performance Dri-Fit Tee',
    price: 29.99,
    category: 'TEES',
    image: 'https://public.readdy.ai/ai/img_res/edited_3f11ee52c9c2492bf01683594cc07e04_bd52eba8.jpg',
  },
  {
    id: 3,
    name: 'Nightmare Mesh Back Cap',
    price: 29.99,
    category: 'CAPS',
    image: 'https://public.readdy.ai/ai/img_res/edited_ca7618e7129f7eaf563f811b424bc58c_bd52eba8.jpg',
    badge: 'BESTSELLER',
    variants: [
      {
        id: 'cap-black',
        label: 'Black',
        color: '#1a1a1a',
        image: 'https://public.readdy.ai/ai/img_res/edited_ca7618e7129f7eaf563f811b424bc58c_bd52eba8.jpg',
      },
      {
        id: 'cap-pink',
        label: 'Pink',
        color: '#FF69B4',
        image: 'https://public.readdy.ai/ai/img_res/edited_238d12b1d24bd4f34c6034273095be8a_4ca49dcc.jpg',
      },
      {
        id: 'cap-black-red',
        label: 'Black/Red',
        color: '#8B0000',
        image: 'https://public.readdy.ai/ai/img_res/edited_987f1bd8613a9c7932df98804decaf43_be04b57f.jpg',
      },
    ],
  },
  {
    id: 4,
    name: 'Nightmare 100% Cotton Tee',
    price: 29.99,
    category: 'TEES',
    image: 'https://public.readdy.ai/ai/img_res/edited_29566bda1c331615d12b5177328394d4_bd52eba8.jpg',
  },
  {
    id: 5,
    name: 'Nightmare Head Sweatband',
    price: 16.99,
    category: 'ACCESSORIES',
    image: 'https://public.readdy.ai/ai/img_res/edited_ee3efdd284a83f468cf8144920e6d846_bd52eba8.jpg',
    variants: [
      {
        id: 'v1',
        label: 'Nightmare Logo',
        color: '#1a1a1a',
        image: 'https://public.readdy.ai/ai/img_res/edited_f0de5df9063073e2c05a7050aad3cf26_bd52eba8.jpg',
      },
      {
        id: 'v2',
        label: 'Logo Emblem',
        color: '#8B0000',
        image: 'https://public.readdy.ai/ai/img_res/edited_314e30faa19da24d60dd8ea28c5d87a7_bd52eba8.jpg',
      },
      {
        id: 'v3',
        label: 'Pink',
        color: '#FF69B4',
        image: 'https://public.readdy.ai/ai/img_res/edited_3de828f77fc3a9d1948270deeb92ab7b_bd52eba8.jpg',
      },
    ],
  },
  {
    id: 8,
    name: 'Nightmare Silicone Wristbands',
    price: 2.99,
    category: 'ACCESSORIES',
    sizeType: 'wristband',
    image: 'https://public.readdy.ai/ai/img_res/15c21df2d5a9acc5fd198f9da15e5ec1.jpg',
    badge: 'NEW',
  },
];
